import React from 'react';
import { Box, Button, Container, Grid, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { motion } from 'framer-motion';
import AccentButton from '../Common/AccentButton';
import { COLORS } from '../../Constants/styles';


const benefits = [
  {
    title: 'Holistic Child Development',
    description: 'Fostering physical, emotional, and social growth through joyful play and movement.',
    delay: 100,
  },
  {
    title: 'Expert-Led Programs',
    description: 'Age-appropriate coaching and mentorship from trained professionals who care. ',
    delay: 200,
  },
  {
    title: 'Inclusive & Safe Environments',
    description: 'Welcoming every child to learn, play, and grow with confidence.',
    delay: 300,
  },
  {
    title: 'Strong School Partnerships',
    description: 'Seamless integration of sports and PE into daily learning for lasting impact.',
    delay: 400,
  },
];

const JoinCommunity = () => {
  return (
    <>
      {/* Join Our Community Section */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          py: 6,
          px: 6,
          flexDirection: 'column',
          alignItems: 'center',
          backgroundColor: COLORS.accentDarkGreen,
        }}
      >
        <Container maxWidth="xl">

          <Grid container spacing={4} justifyContent="center">
            <Grid item xs={12} md={6} sx={{ px: { xs: 2, md: 4 }, textAlign: { xs: 'center', md: 'left' }, }}>
              <Typography
                variant="h3"
                sx={{
                  mb: 2,
                  color: COLORS.accentLime,

                }}
              >
                Ready to Transform Sports Education in Your School ? 
              </Typography>
              <Typography variant="body2" sx={{ color: COLORS.whiteSemiTransparent, fontFamily: 'Inter', fontWeight: 600, fontSize: '1rem', lineHeight: 1.4 }}>
                Partner with Grassroots Sports Education & Services to deliver engaging, curriculum-aligned Sports & Physical Education programs that build healthier, happier, and more confident children.
              </Typography>
            </Grid>

            <Grid item xs={12} md={6} sx={{
              display: 'flex',
              justifyContent: { xs: 'center', md: 'flex-end' },
              alignItems: 'center',
              gap: 2,
              flexDirection: { xs: 'column', sm: 'row' },
              textAlign: 'center',
            }}>
              <Box sx={{ display: 'flex', justifyContent: 'end', gap: 2 }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: COLORS.white,
                    color: COLORS.accentDarkGreen,
                    border: `1px solid ${COLORS.white}`,
                    fontWeight: 600,
                    fontFamily: "'Big Shoulders Text', sans-serif",
                    textDecoration: 'none',
                    textTransform: 'uppercase',
                    '&:hover': {
                      bgcolor: COLORS.accentOffWhite,
                      color: COLORS.accentDarkGreen,
                      border: `1px solid ${COLORS.accentOffWhite}`,
                    },
                  }}
                  href="https://forms.gle/zQNsoHPHSqB75vy9A"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Partner With Us
                </Button>

                <AccentButton
                  label="Request a Consultation"
                  href="https://forms.gle/wFuKrXRqmvgq53VP7"
                  target="_blank"
                  rel="noopener noreferrer"
                />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Benefits Section */}
      <Box
        sx={{
          backgroundColor: COLORS.white, 
          py: 6,
          px: 2,
        }}
      >
        <Container maxWidth="xl">

          <Grid container spacing={4} justifyContent="center">
            {benefits.map((benefit, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <motion.div
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: benefit.delay / 1000 }}
                  viewport={{ once: true }}
                >
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    textAlign="center"
                    gap={2}
                  >
                    <CheckCircleOutlineIcon
                      sx={{ fontSize: 50, color: COLORS.accentDarkGreen, }}
                    />
                    <Typography
                      variant="h6"
                      fontWeight="normal"
                      color={COLORS.pureBlack}
                      sx={{
                        fontFamily: "'Big Shoulders Text', sans-serif",
                        textDecoration: 'none',
                        textTransform: 'uppercase',
                        fontWeight: 600,
                      }}
                    >
                      {benefit.title}
                    </Typography>
                    <Typography variant="body2" color={COLORS.accentBlackTransparent}
                      sx={{
                        fontFamily: "Inter", letterSpacing: 0, lineHeight: 1.4, wordSpacing: "0px", textTransform: "none", textAlign: "center", 
                      }}>
                      {benefit.description}
                    </Typography>
                  </Box>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default JoinCommunity;
